var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeepa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 3.0501V1.52505V0H4.46875C5.85313 0 5.875 0 5.875 0.062247C5.875 0.0964829 5.8875 0.130719 5.90625 0.140056C5.925 0.149393 5.9375 0.662931 5.9375 3.01898L6.00625 3.03454C6.04688 3.04388 6.72188 3.0501 8.9375 3.0501L8.96875 3.12791C8.9875 3.1746 9 3.71303 9 4.51291C9 5.66137 8.99375 5.82632 8.95 5.86678C8.90938 5.90724 8.69687 5.91347 5.96875 5.91347V7.4074C5.96875 8.6928 5.9625 8.90755 5.92188 8.94801C5.88125 8.98847 5.69688 8.9947 4.57188 8.98536C3.85313 8.97913 3.21875 8.96357 3.0625 8.93245L3.07188 7.45719C3.075 6.30874 3.06875 5.97571 3.04063 5.9477C3.0125 5.9228 2.59375 5.91347 1.59375 5.91347C0.678125 5.91347 0.1875 5.90413 0.1875 5.88234C0.1875 5.86367 0.146875 5.85122 0 5.85122V3.0501H3.0625Z",
    fill: "currentColor         "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepa);
export default __webpack_public_path__ + "static/media/keepa.228f8e7b64a0b466cc15317148f495f7.svg";
export { ForwardRef as ReactComponent };